import React from 'react';
import EfIcon from '../ef-icon';
import EfImg from '../ef-img';
import EfScroll from '../ef-scroll';
import EfScrollItem from '../ef-scroll/EfScrollItem';
import './index.scss';

export interface EfUsersStoriesItemProps {
    /**
     * 图片链接
     */
    pc: string;
    /**
     * 描述
     */
    desc?: string;
    /**
     * 用户图标
     */
    user_icon?: string;
    /**
     * 用户名
     */
    user_name?: string;
}
interface EfUsersStoriesProps {
    /**
     * aaa
     */
    list?: EfUsersStoriesItemProps[];
}

/**
 * 维护:谢保林
 *
 * 用户故事
 */
const EfUsersStories: React.FC<EfUsersStoriesProps> = ({ list }) => {
    const prefixCls = `ef-users-stories`;
    const classes = prefixCls;
    if (!list?.length) {
        return null;
    }

    return (
        <div className={classes}>
            <EfScroll>
                {list?.map((item: EfUsersStoriesItemProps, index: number) => {
                    return (
                        <EfScrollItem key={index}>
                            <div className={`${prefixCls}-img`}>
                                <EfImg pc={item.pc} />
                            </div>
                            <div className={`${prefixCls}-msg`}>
                                <div className={`${prefixCls}-text`}>{item.desc}</div>
                            </div>
                            <div className={`${prefixCls}-user`}>
                                <EfIcon pc={item.user_icon} className={`${prefixCls}-icon`} />
                                <div className={`${prefixCls}-user-name`}>{item.user_name}</div>
                            </div>
                        </EfScrollItem>
                    );
                })}
            </EfScroll>
        </div>
    );
};

export default EfUsersStories;
